import { bindCreateAsyncThunkToState } from '@op/services'
import type { RootState } from './reducers'

export const createAsyncThunk = bindCreateAsyncThunkToState<RootState>()
